<template>
  <page-layout
    :header="isMobile"
    :loaded="currentUserLoaded"
    title="Recruiting Dashboard"
  >
    <div class="content-main">
      <div class="content-main__centered">
        <v-tabs
          color="primary"
          class="mb-6 recruiting-tabs"
          v-if="isStudentDBEnabled"
        >
          <v-tabs-slider color="primary" />
          <v-tab to="/recruiting">PR Recruiting</v-tab>
          <v-tab to="/territory-info">Territory Info</v-tab>
        </v-tabs>

        <h4 class="appMain--text mb-2">Hello {{ userName }}!</h4>
        <p class="mb-6">
          Track your recruiting activity and stay on top of your outreach goals.
        </p>

        <!-- Contact Search -->
        <recruiting-home-search class="mb-6" />

        <!-- Office Overview -->
        <recruiting-office-overview />

        <!-- Manager Onboarding Video Banner -->
        <recruiting-home-intro-video />

        <!-- Manager Help Links -->
        <recruiting-home-help />
      </div>
    </div>
  </page-layout>
</template>

<script>
import { mapGetters } from 'vuex';
import RecruitingHomeHelp from './components/RecruitingHomeHelp.vue';
import RecruitingHomeIntroVideo from './components/RecruitingHomeIntroVideo.vue';
import RecruitingHomeSearch from './components/RecruitingHomeSearch.vue';
import RecruitingOfficeOverview from './components/RecruitingOfficeOverview.vue';

export default {
  name: 'RecruitingHome',
  components: {
    RecruitingHomeHelp,
    RecruitingHomeIntroVideo,
    RecruitingHomeSearch,
    RecruitingOfficeOverview,
  },
  computed: {
    ...mapGetters('users', ['currentUser', 'currentUserLoaded']),

    userName() {
      return this.currentUser?.first_name || '';
    },

    isStudentDBEnabled() {
      return this.isFeatureEnabled('student_db');
    },
  },
};
</script>

<style lang="less">
.recruiting-tabs {
  flex: 0 !important;

  .v-tab {
    flex: 1;
  }
}
</style>
